import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import AdminBackNavigation from "../../../../components/CommonComponents/AdminBackNavigation";
import backarrow from "../../../../components/Images/backarrow.svg";
import Response_Processing from "../../../../../src/layout/Others/Response_Processing";
import Select from "react-select";
import { toast } from "react-toastify";
import AdminSaveHeader from "../../../../components/CommonComponents/AdminSaveHeader";
import MessageLabel from "../../../../components/CommonComponents/MessageLabel";
import FormContainer from "../../../../components/CommonComponents/FormContainer";
import LeftWrapper from "../../../../components/CommonComponents/LeftWrapper";
import Wrapper from "../../../../components/CommonComponents/Wrapper";
import MessageHeading from "../../../../components/CommonComponents/MessageHeading";
import MessageBox from "../../../../components/CommonComponents/MessageBox";
import RightWrapper from "../../../../components/CommonComponents/RightWrapper";
import AdminSwitch from "../../../../components/CommonComponents/AdminSwitch";
import { useMyContext } from "../../../../components/Provider/CommonProvider";
import { getItem } from "../../../../Utils/localStorageUtils";
import AdminCustomInput from "../../../../components/CommonComponents/AdminCustomInput";
import { IoMdInformationCircle } from "react-icons/io";
import AdminCustomSelect from "../../../../components/CommonComponents/AdminCustomSelect";
import { Tooltip, OverlayTrigger } from 'react-bootstrap';
import { IoMdInformationCircleOutline } from "react-icons/io";
import AdminImageUploadZone from "../../../../components/CommonComponents/AdminImageUploadZone";
import MessageHeadingWithBadge from "../../../../components/CommonComponents/MessageHeadingWithBadge";

function Transcoding_Setting() {
  const baseUrl = process.env.REACT_APP_Baseurl
  const labelSource = 'site-settings'
  const settingStoreApi = `${baseUrl}/admin/setting/store`
  const labelApi = `${baseUrl}/admin/Label-Management/list-source?source=${labelSource}`
  const adminSettingsGetApi = `${baseUrl}/admin/main-settings/get`
  const adminSettingsUpdateApi = `${baseUrl}/admin/main-settings/update`
  // Add storage settings API
  const storageSettingsApi = `${baseUrl}/admin/storage_index`
  const performanceSettingsApi = `${baseUrl}/admin/site/transcoding-setting`

  const { fetchRequest } = useMyContext()
  const [formData, setFormData] = useState()
  const [labelDisplay, setLabelDisplay] = useState([]);
  const [formDataError, setFormDataError] = useState({})
  const [withOutRefresh, setWithOutRefresh] = useState(false)
  const [showOverlay, setShowOverlay] = useState(false);
  const [isCheckingFfmpeg, setIsCheckingFfmpeg] = useState(false);
  const [selectedWatermarkFile, setSelectedWatermarkFile] = useState(null);
  const [watermarkImagePreview, setWatermarkImagePreview] = useState(null);
  // Add storage settings state
  const [storageSettings, setStorageSettings] = useState(null);
  const [performanceSettings, setPerformanceSettings] = useState({
    concurrency: 1,
    threads: 2,
    filter_threads: 1,
    hls_time: 10
  });
  const [isBunnyCdnEnabled, setIsBunnyCdnEnabled] = useState(false);
  const token = getItem("access_token")
  const ffmpegChecker = `${process.env.REACT_APP_Baseurl}/admin/ffmpeg-checker`

  const watermarkImageUploadApi = `${baseUrl}/admin/main-settings/watermark-upload`

  const combinedRef = useRef({
    transcoding_resolution: null,
  });
  const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  const video_codec_options = [
    { name: 'H.264', value: 'libx264' },
    { name: 'H.265', value: 'libx265' },
    // { name: 'H.266', value: 'libvvenc' },
    // { name: 'AV1', value: 'libaom-av1' },
    { name: 'VP9', value: 'libvpx-vp9' }
  ]

  // Dynamic preset options based on codec
  const getPresetOptions = (codec) => {
    switch (codec) {
      case 'libx264': // H.264
        return [
          { name: 'Ultrafast', value: 'ultrafast' },
          { name: 'Superfast', value: 'superfast' },
          { name: 'Veryfast', value: 'veryfast' },
          { name: 'Faster', value: 'faster' },
          { name: 'Fast', value: 'fast' },
          { name: 'Medium', value: 'medium' },
          { name: 'Slow', value: 'slow' },
          { name: 'Slower', value: 'slower' },
          { name: 'Veryslow', value: 'veryslow' }
        ];
      case 'libx265': // H.265
        return [
          { name: 'Ultrafast', value: 'ultrafast' },
          { name: 'Superfast', value: 'superfast' },
          { name: 'Veryfast', value: 'veryfast' },
          { name: 'Faster', value: 'faster' },
          { name: 'Fast', value: 'fast' },
          { name: 'Medium', value: 'medium' },
          { name: 'Slow', value: 'slow' },
          { name: 'Slower', value: 'slower' },
          { name: 'Veryslow', value: 'veryslow' },
          { name: 'Placebo', value: 'placebo' }
        ];
      case 'libvvenc': // H.266
        return [
          { name: 'Faster', value: 'faster' },
          { name: 'Fast', value: 'fast' },
          { name: 'Medium', value: 'medium' },
          { name: 'Slow', value: 'slow' },
          { name: 'Slower', value: 'slower' }
        ];
      case 'libaom-av1': // AV1
        return [
          { name: 'Speed 8 (Fastest)', value: '8' },
          { name: 'Speed 7', value: '7' },
          { name: 'Speed 6', value: '6' },
          { name: 'Speed 5', value: '5' },
          { name: 'Speed 4', value: '4' },
          { name: 'Speed 3', value: '3' },
          { name: 'Speed 2', value: '2' },
          { name: 'Speed 1', value: '1' },
          { name: 'Speed 0 (Slowest)', value: '0' }
        ];
      case 'libvpx-vp9': // VP9
        return [
          { name: 'Speed 5 (Fastest)', value: '5' },
          { name: 'Speed 4', value: '4' },
          { name: 'Speed 3', value: '3' },
          { name: 'Speed 2', value: '2' },
          { name: 'Speed 1', value: '1' },
          { name: 'Speed 0 (Best Quality)', value: '0' }
        ];
      default:
        return [
          { name: 'Ultrafast', value: 'ultrafast' },
          { name: 'Superfast', value: 'superfast' },
          { name: 'Faster', value: 'faster' },
          { name: 'Medium', value: 'medium' }
        ];
    }
  };


  // Get current preset options based on selected codec
  const currentPresetOptions = getPresetOptions(formData?.ffmpeg_conf?.video_codec);

  // Codec descriptions for tooltips
  const getCodecDescription = (codec) => {
    switch (codec) {
      case 'libx264':
        return {
          title: 'H.264 (AVC)',
          description: 'Most widely supported codec. Best compatibility across all devices and platforms. Good balance of quality and file size.',
          pros: '✓ Universal compatibility\n✓ Hardware acceleration\n✓ Fast encoding',
          cons: '✗ Larger file sizes than newer codecs\n✗ Limited to 4K',
          useCase: 'Recommended for: General streaming, legacy device support'
        };
      case 'libx265':
        return {
          title: 'H.265 (HEVC)',
          description: 'Next-generation codec with 50% better compression than H.264. Supports 4K, 8K, and HDR content.',
          pros: '✓ 50% smaller files than H.264\n✓ 4K/8K support\n✓ HDR compatibility',
          cons: '✗ Slower encoding\n✗ Limited older device support\n✗ Patent licensing',
          useCase: 'Recommended for: 4K content, bandwidth-limited streaming'
        };
      case 'libvvenc':
        return {
          title: 'H.266 (VVC)',
          description: 'Latest video codec standard offering 30% better compression than H.265. Designed for 4K/8K, VR/AR, and high dynamic range content.',
          pros: '✓ 30% better compression than H.265\n✓ Superior 8K/VR support\n✓ Advanced HDR and wide color gamut\n✓ Better parallel processing',
          cons: '✗ Very slow encoding\n✗ High computational requirements\n✗ Limited hardware/software support\n✗ Patent licensing complexity',
          useCase: 'Recommended for: Future-proof 8K content, VR/AR applications'
        };
      case 'libaom-av1':
        return {
          title: 'AV1',
          description: 'Open-source, royalty-free codec developed by major tech companies. Similar compression to H.265.',
          pros: '✓ Royalty-free\n✓ Open source\n✓ Good compression',
          cons: '✗ Very slow encoding\n✗ High CPU usage\n✗ Limited hardware support',
          useCase: 'Recommended for: Cost-conscious projects, open-source preference'
        };
      case 'libvpx-vp9':
        return {
          title: 'VP9',
          description: 'Google\'s open-source codec. Used by YouTube and other Google services. Good alternative to H.265.',
          pros: '✓ Royalty-free\n✓ Good compression\n✓ Web-optimized',
          cons: '✗ Slow encoding\n✗ Limited device support\n✗ Complex tuning',
          useCase: 'Recommended for: Web streaming, Google ecosystem'
        };
      default:
        return {
          title: 'Select a codec',
          description: 'Choose a video codec to see detailed information',
          pros: '',
          cons: '',
          useCase: ''
        };
    }
  };

  // Get current codec description
  const currentCodecInfo = getCodecDescription(formData?.ffmpeg_conf?.video_codec);

  // Preset description based on codec
  const getPresetDescription = (codec) => {
    switch (codec) {
      case 'libx264':
      case 'libx265':
        return 'Speed presets control encoding time vs quality. Faster = quicker encoding but larger files. Slower = better compression but takes longer.';
      case 'libvvenc':
        return 'H.266 speed presets control encoding efficiency. Faster presets encode quickly but with larger files. Slower presets provide maximum compression but require significantly more time.';
      case 'libaom-av1':
        return 'Speed settings for AV1. Higher numbers (8) encode faster but with larger files. Lower numbers (0) provide best compression.';
      case 'libvpx-vp9':
        return 'VP9 speed settings. Speed 5 is fastest encoding, Speed 0 provides best quality but takes much longer.';
      default:
        return 'Select a codec first to see preset descriptions.';
    }
  };

  // Handle multi-tenant and thumbnail specific inputs
  const handleMultiTenantThumbnailInput = (e) => {
    const { name, value, type, checked } = e.target;

    if (type === "checkbox") {
      if (name === "multiTenantStatus" || name === "generateThumbnailStatus" || name === "generateThumbnailHLSProfile" || name === "watermarkEnabled") {
        // Handle mutual exclusion for thumbnail generation toggles
        if (name === "generateThumbnailStatus" && checked) {
          // If Generate Thumbnails is turned ON, turn OFF Generate Thumbnail HLS Profile
          setFormData((prev) => ({
            ...prev,
            generateThumbnailStatus: "true",
            generateThumbnailHLSProfile: false,
          }));
        } else if (name === "generateThumbnailHLSProfile" && checked) {
          // If Generate Thumbnail HLS Profile is turned ON, turn OFF Generate Thumbnails
          setFormData((prev) => ({
            ...prev,
            generateThumbnailHLSProfile: true,
            generateThumbnailStatus: "false",
          }));
        } else {
          // Handle normal toggle behavior (turning OFF)
          setFormData((prev) => ({
            ...prev,
            [name]: name === "generateThumbnailStatus" ? (checked ? "true" : "false") : checked,
          }));
        }
      }
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: name === "thumbnailIntervalSeconds" ? parseInt(value) || 60 : value,
      }));
      setFormDataError((prev) => ({
        ...prev,
        [name]: '',
      }));
    }
  };

  const handleInput = async (e) => {
    const { name, value, type, checked } = e.target;

    if (type === "checkbox") {
      if (name === "transcoding_access") {
        if (checked && token) {
          // Check if site_storage is active before validating ffmpeg
          const isSiteStorageActive = storageSettings?.site_storage == 1;

          if (isSiteStorageActive) {
            // Only check ffmpeg if site_storage is active
            setIsCheckingFfmpeg(true);
            try {
              await wait(1000);
              const response = await fetchRequest({
                method: 'GET',
                url: ffmpegChecker,
                params: {},
                data: {},
              });

              if (response?.status) {
                setFormData((prev) => ({
                  ...prev,
                  [name]: 1,
                }));
                toast.success("FFmpeg transcoding check passed.");
              } else {
                setFormData((prev) => ({
                  ...prev,
                  [name]: 0,
                }));
                toast.error("FFmpeg check failed.");
              }
            } catch (error) {
              setFormData((prev) => ({
                ...prev,
                [name]: 0,
              }));
              toast.error(`Server Error: ${error?.response?.data?.message || error}`);
            } finally {
              setIsCheckingFfmpeg(false);
            }
          } else {
            // Site storage is not active, skip ffmpeg check and enable transcoding directly
            setFormData((prev) => ({
              ...prev,
              [name]: 1,
            }));
            toast.success("Transcoding enabled");
          }
        } else {
          // unchecked, or no token
          setFormData((prev) => ({
            ...prev,
            [name]: 0,
          }));
        }
      } else {
        // Other checkboxes
        setFormData((prev) => ({
          ...prev,
          [name]: checked ? 1 : 0,
        }));
      }
    }

    if (type === 'select-one') {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
      setFormDataError((prev) => ({
        ...prev,
        [name]: '',
      }));
    }
    if (type === 'text') {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
      setFormDataError((prev) => ({
        ...prev,
        [name]: '',
      }));
    }
  };

  const handleFfmpegInput = (e) => {
    const { value, name, type } = e.target;

    if (type === 'select-one') {
      setFormData(prev => {
        const ffmpegUpdate = { ...prev?.ffmpeg_conf };
        ffmpegUpdate[name] = value

        // If codec is changed, reset the preset to avoid incompatible combinations
        if (name === 'video_codec') {
          ffmpegUpdate.preset = '';
        }

        return {
          ...prev,
          ffmpeg_conf: ffmpegUpdate
        }
      })

      setFormDataError(prev => ({
        ...prev,
        [name]: '',
        // Also clear preset error when codec changes
        ...(name === 'video_codec' && { preset: '' })
      }))
    }
  }

  const handlePerformanceInput = (e) => {
    const { name, value } = e.target;
    setPerformanceSettings(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const multiSelectLabel = (array, valueKey, labelKey) => {
    return Array.isArray(array) ? array?.map((item) => ({
      value: item[valueKey],
      label: item[labelKey]
    })) : [];
  };

  const handleMultiSelect = (selectedOptions, actionMeta) => {
    setFormData((prev) => ({
      ...prev,
      [actionMeta.name]: selectedOptions
    }))
    setFormDataError((prev) => ({
      ...prev,
      [actionMeta.name]: ""
    }))
  }

  const formValidation = () => {
    let formIsValid = true;

    // Validate transcoding resolution for all storage types (including BunnyCDN)
    if (!formData?.transcoding_resolution || formData?.transcoding_resolution.length === 0) {
      setFormDataError((prevFormData) => ({
        ...prevFormData,
        transcoding_resolution: "Transcoding resolution cannot be empty.",
      }));
      formIsValid = false;
    }

    if (!formData?.testing_transcoding_url?.trim()) {
      setFormDataError((prevFormData) => ({
        ...prevFormData,
        testing_transcoding_url: "URL cannot be empty.",
      }));
      formIsValid = false;
    }
    else {
      const urlRegex = /^(http|https|rtmp):\/\/[^\s$.?#].[^\s]*$/i;
      if (!urlRegex.test(formData.testing_transcoding_url.trim())) {
        setFormDataError((prevFormData) => ({
          ...prevFormData,
          testing_transcoding_url: "Invalid URL format. Use http://, https://, or rtmp://",
        }));
        formIsValid = false;
      }
    }

    if (!formData?.ffmpeg_conf?.video_codec) {
      setFormDataError(prev => ({
        ...prev,
        video_codec: "Video Codec cannot be empty"

      }))
      combinedRef.current['video_codec'].focus();
      formIsValid = false;
    }
    if (!formData?.ffmpeg_conf?.preset) {
      setFormDataError(prev => ({
        ...prev,
        preset: "FFMPEG Preset cannot be empty"

      }))
      combinedRef.current['preset'].focus();
      formIsValid = false;
    }

    return formIsValid;
  };

  // Handle watermark image upload
  const handleWatermarkImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedWatermarkFile(file);
      // Create preview URL
      const previewUrl = URL.createObjectURL(file);
      setWatermarkImagePreview(previewUrl);

      setFormDataError((prev) => ({
        ...prev,
        watermarkImage: '',
      }));
    }
  };

  // Handle watermark image deletion
  const handleWatermarkImageDelete = (fieldName) => {
    setSelectedWatermarkFile(null);
    setWatermarkImagePreview(null);

    // Clear the file input
    const fileInput = document.getElementById('watermark-image-upload');
    if (fileInput) {
      fileInput.value = '';
    }

    setFormData((prev) => ({
      ...prev,
      watermarkImageUrl: null,
    }));
  };

  // Upload watermark image to multi-tenant server
  const uploadWatermarkImage = async () => {
    if (!selectedWatermarkFile) return null;

    try {
      const uploadFormData = new FormData();
      uploadFormData.append('watermarkImage', selectedWatermarkFile);
      uploadFormData.append('tenantId', formData?.multiTenantID || 'default');

      const response = await fetch(watermarkImageUploadApi, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
        },
        body: uploadFormData,
      });

      if (response.ok) {
        const result = await response.json();
        return result.imageUrl || result.data?.imageUrl;
      } else {
        throw new Error('Failed to upload watermark image');
      }
    } catch (error) {
      console.error('Error uploading watermark image:', error);
      toast.error('Failed to upload watermark image: ' + error.message);
      return null;
    }
  };


  const handleSubmit = async () => {
    setShowOverlay(true)
    const formDataAdd = {};

    // Exclude admin settings and resolutionOption from general settings
    const adminSettingsKeys = [
      'multiTenantStatus',
      'multiTenantStorageServiceUrl',
      'multiTenantID',
      'generateThumbnailStatus',
      'thumbnailIntervalSeconds',
      'generateThumbnailHLSProfile',
      'watermarkEnabled',
      'watermarkImageUrl',
      'watermarkOpacity',
      'watermarkPosition'
    ];

    for (const key in formData) {
      if (![...adminSettingsKeys, "resolutionOption", "Storage_setting"].includes(key)) {
        formDataAdd[key] = formData[key]
      }
    }

    // Process transcoding_resolution for all storage types
    if (formDataAdd?.transcoding_resolution) {
      formDataAdd.transcoding_resolution = formDataAdd?.transcoding_resolution?.map((item) => item?.value).join(",")
    }
    await fetchRequest({
      method: 'POST',
      url: `${settingStoreApi}`,
      params: {},
      data: { ...formDataAdd },
    })
      .then(response => {
        if (response?.status) {
          // Remove individual toast - will be handled by handleUpdate
          setWithOutRefresh((prev) => !prev)
          setShowOverlay(false)
        }
      }).catch((error => {
        toast.error(error?.response?.data?.message)
        setShowOverlay(false)
      }))
  };

  // Update admin settings (multi-tenant & thumbnail)
  const updateAdminSettings = async () => {
    try {
      // Upload watermark image if selected
      let watermarkImageUrl = formData?.watermarkImageUrl;
      if (selectedWatermarkFile) {
        watermarkImageUrl = await uploadWatermarkImage();
        if (!watermarkImageUrl) {
          throw new Error('Failed to upload watermark image');
        }
      }

      const adminSettingsData = {
        multiTenantStatus: formData?.multiTenantStatus,
        multiTenantStorageServiceUrl: formData?.multiTenantStorageServiceUrl,
        multiTenantID: formData?.multiTenantID,
        generateThumbnailStatus: formData?.generateThumbnailStatus,
        thumbnailIntervalSeconds: formData?.thumbnailIntervalSeconds,
        generateThumbnailHLSProfile: formData?.generateThumbnailHLSProfile,
        watermarkEnabled: formData?.watermarkEnabled || false,
        watermarkImageUrl: watermarkImageUrl,
        watermarkOpacity: formData?.watermarkOpacity || 0.7,
        watermarkPosition: formData?.watermarkPosition || 'bottom-right'
      };

      const response = await fetchRequest({
        method: 'POST',
        url: adminSettingsUpdateApi,
        data: adminSettingsData
      });

      if (response?.status) {
        // Remove individual toast - will be handled by handleUpdate
      }
    } catch (error) {
      toast.error('Failed to update admin settings: ' + (error?.response?.data?.message || error.message));
    }
  };

  // Update performance settings (concurrency, threads, etc.)
  const updatePerformanceSettings = async () => {
    try {
      const response = await fetchRequest({
        method: 'POST',
        url: performanceSettingsApi,
        data: performanceSettings
      });

      if (response?.status) {
        // Updated successfully
      }
    } catch (error) {
      toast.error('Failed to update performance settings: ' + (error?.response?.data?.message || error.message));
    }
  };

  // Sync transcoding settings with BunnyCDN via internal API
  const updateBunnyCdnTranscoding = async () => {
    if (!isBunnyCdnEnabled) {
      return;
    }

    try {
      const resolutions = formData?.transcoding_resolution?.map((item) => item?.value).join(",");

      await fetchRequest({
        method: 'POST',
        url: `${baseUrl}/admin/site/sync-bunny-cdn-transcoding`,
        data: {
          EnabledResolutions: resolutions
        }
      });
    } catch (error) {
      console.error('Failed to update BunnyCDN transcoding settings:', error);
      toast.error('Failed to sync resolutions with BunnyCDN. Please check your storage settings.');
    }
  };

  const handleUpdate = async () => {
    if (formValidation()) {
      setShowOverlay(true)
      try {
        // Update general settings (including ffmpeg_conf)
        await handleSubmit()

        // Update admin settings (multi-tenant & thumbnail)
        await updateAdminSettings()

        // Update performance settings
        await updatePerformanceSettings()

        // Sync with BunnyCDN if enabled
        if (isBunnyCdnEnabled) {
          await updateBunnyCdnTranscoding()
        }

        toast.success('All settings updated successfully')
      } catch (error) {
        toast.error('Failed to update settings: ' + (error?.message || error))
      } finally {
        setShowOverlay(false)
      }
    }
  }

  // Fetch admin settings (multi-tenant & thumbnail)
  const fetchAdminSettings = async () => {
    try {
      const response = await fetchRequest({
        method: 'GET',
        url: adminSettingsGetApi,
      });

      if (response?.status && response?.data) {
        setFormData((prev) => ({
          ...prev,
          multiTenantStatus: response.data.multiTenantStatus || false,
          multiTenantStorageServiceUrl: response.data.multiTenantStorageServiceUrl || 'http://localhost:3001',
          multiTenantID: response.data.multiTenantID || process.env.REACT_APP_DB_NAME || '',
          generateThumbnailStatus: response.data.generateThumbnailStatus || 'false',
          thumbnailIntervalSeconds: response.data.thumbnailIntervalSeconds || 60,
          generateThumbnailHLSProfile: response.data.generateThumbnailHLSProfile || false,
          watermarkEnabled: response.data.watermarkEnabled || false,
          watermarkImageUrl: response.data.watermarkImageUrl || null,
          watermarkOpacity: response.data.watermarkOpacity || 0.7,
          watermarkPosition: response.data.watermarkPosition || 'bottom-right'
        }));

        // Set watermark image preview if URL exists
        if (response.data.watermarkImageUrl) {
          setWatermarkImagePreview(response.data.watermarkImageUrl);
        }
      }
    } catch (error) {
      console.error('Failed to fetch admin settings:', error);
      // Set default values on error
      setFormData((prev) => ({
        ...prev,
        multiTenantStatus: false,
        multiTenantStorageServiceUrl: 'http://localhost:3001',
        multiTenantID: process.env.REACT_APP_DB_NAME || '',
        generateThumbnailStatus: 'false',
        thumbnailIntervalSeconds: 60,
        generateThumbnailHLSProfile: false,
        watermarkEnabled: false,
        watermarkImageUrl: null,
        watermarkOpacity: 0.7,
        watermarkPosition: 'bottom-right'
      }));
    }
  };

  // Fetch storage settings to detect BunnyCDN status
  const fetchStorageSettings = async () => {
    try {
      const response = await fetchRequest({
        method: 'GET',
        url: storageSettingsApi,
        params: {},
        data: {},
      });

      if (response?.status && response?.Storage_setting) {
        setStorageSettings(response.Storage_setting);
        setIsBunnyCdnEnabled(response.Storage_setting.bunnyCdnStorage === 1);
      }
    } catch (error) {
      console.error('Failed to fetch storage settings:', error);
    }
  };

  // Fetch performance settings
  const fetchPerformanceSettings = async () => {
    try {
      const response = await fetchRequest({
        method: 'GET',
        url: performanceSettingsApi,
      });

      if (response?.status && response?.data) {
        setPerformanceSettings(response.data);
      }
    } catch (error) {
      console.error('Failed to fetch performance settings:', error);
    }
  };

  useEffect(async () => {
    await fetchRequest({
      method: 'GET',
      url: `${process.env.REACT_APP_Baseurl}/admin/setting/index`,
      params: {},
      data: {},
    })
      .then(response => {
        if (response?.status) {
          setFormData((prev) => ({
            ...prev,
            ...response?.setting,
            ffmpeg_conf: response?.ffmpeg_conf,
            transcoding_resolution: multiSelectLabel(response?.setting?.selected_transcoding, 'value', 'name'),
            resolutionOption: multiSelectLabel(response?.transcoding_resolution, 'value', 'name'),
          }));
        }
      }).catch((error => {
        console.error(error)
      }))

    // Also fetch admin settings and storage settings
    await fetchAdminSettings();
    await fetchStorageSettings();
    await fetchPerformanceSettings();
  }, []);

  const labelFetch = async () => {
    try {
      setShowOverlay(true)
      const response = await fetchRequest({
        method: 'GET',
        url: `${labelApi}`,
        data: {}
      })
      if (response?.status) {
        const result = response?.label_management
        setLabelDisplay(result)
      }
    }
    catch (err) {
      toast.error(err?.response?.data?.message)
    }
    finally {
      setShowOverlay(false)
    }
  }

  useEffect(async () => {
    await labelFetch();
  }, [])

  // BunnyCDN Alert Component
  const BunnyCdnAlert = () => {
    if (!isBunnyCdnEnabled) return null;

    const features = [
      { title: 'Adaptive Bitrate', desc: 'Auto-adjusts quality based on bandwidth', color: '#2563eb', bg: 'rgba(59, 130, 246, 0.1)' },
      { title: 'HLS(H.264) Delivery', desc: 'Secure, multi-bitrate segmented streaming', color: '#059669', bg: 'rgba(16, 185, 129, 0.1)' },
      { title: 'Edge Processing', desc: 'Transcoding performed on cloud nodes', color: '#d97706', bg: 'rgba(245, 158, 11, 0.1)' },
      { title: 'Global CDN', desc: 'Lowest latency through distributed network', color: '#7c3aed', bg: 'rgba(124, 58, 237, 0.1)' }
    ];

    return (
      <div className="card mb-4" style={{
        border: '1px solid rgba(0, 102, 204, 0.1)',
        borderRadius: '16px',
        boxShadow: '0 10px 25px -5px rgba(0, 0, 0, 0.05), 0 8px 10px -6px rgba(0, 0, 0, 0.05)',
        background: '#ffffff',
        overflow: 'hidden'
      }}>

        <div className="card-body p-4">
          <div className="d-flex justify-content-between align-items-start mb-4">
            <div>
              <div className="d-flex align-items-center gap-2 mb-2">
                <h5 className="mb-0" style={{ color: '#1a365d', fontSize: '20px', fontWeight: '700' }}>
                  CDN Transcoding System
                </h5>
                <span className="badge" style={{
                  backgroundColor: '#ecfdf5',
                  color: '#059669',
                  border: '1px solid #10b981',
                  borderRadius: '6px',
                  fontSize: '10px',
                  fontWeight: '600',
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px',
                  padding: '4px 8px'
                }}>
                  Active
                </span>
              </div>
              <p className="mb-0" style={{
                color: '#64748b',
                fontSize: '14px',
                maxWidth: '500px'
              }}>
                Cloud-native video processing is enabled. Your content is automatically optimized for global delivery across all device types.
              </p>
            </div>
            <div style={{
              backgroundColor: '#f1f5f9',
              padding: '10px',
              borderRadius: '12px',
              color: '#3b82f6'
            }}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M17.5 19l4.5-4.5L17.5 10M6.5 19l-4.5-4.5L6.5 10M14.5 4.5L9.5 19.5" />
              </svg>
            </div>
          </div>

          <div className="row g-3">
            {features.map((feature, index) => (
              <div key={index} className="col-12 col-md-6">
                <div className="p-3" style={{
                  backgroundColor: '#f8fafc',
                  borderRadius: '12px',
                  border: '1px solid #f1f5f9',
                  height: '100%'
                }}>
                  <div className="d-flex align-items-center gap-2 mb-1">
                    <div style={{
                      width: '8px',
                      height: '8px',
                      borderRadius: '50%',
                      backgroundColor: feature.color
                    }}></div>
                    <span style={{
                      color: feature.color,
                      fontSize: '13px',
                      fontWeight: '600'
                    }}>
                      {feature.title}
                    </span>
                  </div>
                  <p className="mb-0" style={{
                    color: '#64748b',
                    fontSize: '12px',
                    lineHeight: '1.4'
                  }}>
                    {feature.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <AdminBackNavigation path="/settings" text="Back" />
      {showOverlay && (<Response_Processing />)}
      <AdminSaveHeader heading={labelDisplay?.[0]?.title} saveText={labelDisplay?.[0]?.sub_title} saveMethod={handleUpdate} />
      <FormContainer>
        <LeftWrapper>
          <Wrapper>
            <MessageHeading text="Transcoding Configuration" />

            {/* Enable Transcoding Setting */}
            <FormContainer className={`justify-content-between mb-3`}>
              <div className="col-7"><MessageLabel text={labelDisplay?.[4]?.title} /></div>
              <div className={`col-5 text-end`}>
                <AdminSwitch name={'transcoding_access'} checked={formData?.transcoding_access} onChange={handleInput}
                  disabled={isCheckingFfmpeg}
                />
              </div>
            </FormContainer>



            {/* Transcoding Resolution - Show for all storage types */}
            <>
              <MessageLabel text={labelDisplay?.[2]?.title || "Transcoding Resolution"} className="mandatorySimple" />
              <Select
                ref={(el) => (combinedRef.current.transcoding_resolution = el)}
                options={
                  (isBunnyCdnEnabled || Number(storageSettings?.site_storage) === 1)
                    ? formData?.resolutionOption?.filter(opt =>
                      !opt.value?.toString().includes('4320') &&
                      !opt.label?.toString().includes('4320')
                    )
                    : formData?.resolutionOption
                }
                isMulti
                name={'transcoding_resolution'}
                onChange={handleMultiSelect}
                value={formData?.transcoding_resolution}
                className={`custom-select-multi custom-placeholder theme-text-color mb-3 ${formDataError?.transcoding_resolution && 'custom-input-error'}`}
                placeholder="Select transcoding resolutions..."
              />
              {formDataError?.transcoding_resolution && (
                <div className='d-flex align-items-center gap-1 mb-2'>
                  <IoMdInformationCircle className='errorred' style={{ width: "17px", height: "16px" }} />
                  <MessageBox text={`${formDataError?.transcoding_resolution}`} classname='errorred d-block' />
                </div>
              )}
            </>

            {/* Test URL */}
            <MessageLabel text="Test URL" className="mandatorySimple" />
            <AdminCustomInput id="testing-transcoding-url" name="testing_transcoding_url" value={formData?.testing_transcoding_url} placeHolder={"Test URL"} onChange={handleInput} ref={(el) => (combinedRef.current.website_URL = el)} error={formDataError?.testing_transcoding_url} />
          </Wrapper>

          {/* <Wrapper>
            <MessageHeadingWithBadge text="Thumbnail Generation Settings" badgeText="Beta Version" />
            //Generate Thumbnails
            <FormContainer className="justify-content-between mb-3">
              <div className="col-7">
                <MessageLabel text="Generate Thumbnails" />
              </div>
              <div className="col-5 text-end">
                <AdminSwitch
                  name="generateThumbnailStatus"
                  checked={formData?.generateThumbnailStatus === 'true' || formData?.generateThumbnailStatus === true}
                  onChange={handleMultiTenantThumbnailInput}
                />
              </div>
            </FormContainer>

            // Generate HLS Profile Thumbnails
            <FormContainer className="justify-content-between mb-3">
              <div className="col-7">
                <MessageLabel text="Generate Thumbnail HLS Profile" />
              </div>
              <div className="col-5 text-end">
                <AdminSwitch
                  name="generateThumbnailHLSProfile"
                  checked={formData?.generateThumbnailHLSProfile || false}
                  onChange={handleMultiTenantThumbnailInput}
                />
              </div>
            </FormContainer>

            {((formData?.generateThumbnailStatus === 'true' || formData?.generateThumbnailStatus === true) ||
              (formData?.generateThumbnailHLSProfile === true || formData?.generateThumbnailHLSProfile === 'true')) && (
                <>
                  <MessageLabel text="Thumbnail Generation Interval (seconds)" />
                  <AdminCustomInput
                    id="thumbnail-interval"
                    name="thumbnailIntervalSeconds"
                    value={formData?.thumbnailIntervalSeconds || 60}
                    placeHolder="60"
                    onChange={handleMultiTenantThumbnailInput}
                    error={formDataError?.thumbnailIntervalSeconds}
                    type="number"
                    min="1"
                    max="3600"
                  />

                </>
              )}
          </Wrapper> */}

          {/* <Wrapper>
            <MessageHeading text="Watermark Settings" />
            <FormContainer className="justify-content-between mb-3">
              <div className="col-7">
                <MessageLabel text="Enable Watermark" />
              </div>
              <div className="col-5 text-end">
                <AdminSwitch
                  name="watermarkEnabled"
                  checked={formData?.watermarkEnabled || false}
                  onChange={handleMultiTenantThumbnailInput}
                />
              </div>
            </FormContainer>

            {formData?.watermarkEnabled && (
              <>
                <MessageLabel text="Watermark Image" className="mandatorySimple" />
                <AdminImageUploadZone
                  id="watermark-image-upload"
                  idAttribute="watermark-image-upload"
                  name="watermarkImage"
                  selectedFile={selectedWatermarkFile}
                  uploadedImage={watermarkImagePreview}
                  onChange={handleWatermarkImageUpload}
                  onDelete={handleWatermarkImageDelete}
                  accept="image/*"
                  error={formDataError?.watermarkImage}
                />

                <MessageLabel text="Watermark Opacity" />
                <AdminCustomInput
                  id="watermark-opacity"
                  name="watermarkOpacity"
                  value={formData?.watermarkOpacity || 0.7}
                  placeHolder="0.7"
                  onChange={handleMultiTenantThumbnailInput}
                  error={formDataError?.watermarkOpacity}
                  type="number"
                  min="0.1"
                  max="1.0"
                  step="0.1"
                />

                <MessageLabel text="Watermark Position" />
                <AdminCustomSelect
                  name="watermarkPosition"
                  value={formData?.watermarkPosition || 'bottom-right'}
                  onChange={handleMultiTenantThumbnailInput}
                  options={[
                    { name: 'Top Left', value: 'top-left' },
                    { name: 'Top Right', value: 'top-right' },
                    { name: 'Bottom Left', value: 'bottom-left' },
                    { name: 'Bottom Right', value: 'bottom-right' },
                    { name: 'Center', value: 'center' }
                  ]}
                  error={formDataError?.watermarkPosition}
                  defaultOptionName="Select watermark position"
                />
              </>
            )}
          </Wrapper> */}
        </LeftWrapper>
        <RightWrapper>
          {/* BunnyCDN Status Alert moved to right side */}
          {isBunnyCdnEnabled && (
            <BunnyCdnAlert />
          )}

          {storageSettings?.site_storage === 1 && (
            <>
              <Wrapper>
                {/* Video Codec Section */}
                <MessageHeading text="FFmpeg Video Codec Options" />

                <MessageLabel text={labelDisplay?.[16]?.sub_title || "Select Ffmpeg Video Codec option"} className="mandatorySimple" />
                {/* Custom Codec Selection */}
                <div className="codec-selector mb-3">
                  <div className="row g-2">
                    {video_codec_options
                      .filter(codec => storageSettings?.site_storage === 1 ? codec.value === 'libx264' : true)
                      .map((codec) => (
                        <div key={codec.value} className="col-12 col-md-6 col-lg-4">
                          <OverlayTrigger
                            placement="left"
                            overlay={
                              <Tooltip id={`codec-${codec.value}-tooltip`} style={{ maxWidth: '350px' }}>
                                <div style={{ textAlign: 'left', padding: '8px' }}>
                                  <strong>{getCodecDescription(codec.value).title}</strong><br />
                                  <span style={{ fontSize: '0.9em' }}>{getCodecDescription(codec.value).description}</span><br /><br />
                                  <strong style={{ color: '#28a745' }}>Advantages:</strong><br />
                                  <span style={{ fontSize: '0.85em', whiteSpace: 'pre-line' }}>{getCodecDescription(codec.value).pros}</span><br /><br />
                                  <strong style={{ color: '#ffc107' }}>Limitations:</strong><br />
                                  <span style={{ fontSize: '0.85em', whiteSpace: 'pre-line' }}>{getCodecDescription(codec.value).cons}</span><br /><br />
                                  <em style={{ color: '#17a2b8', fontSize: '0.85em' }}>{getCodecDescription(codec.value).useCase}</em>
                                </div>
                              </Tooltip>
                            }
                          >
                            <div
                              className={`codec-option p-2 border rounded cursor-pointer d-flex align-items-center ${formData?.ffmpeg_conf?.video_codec === codec.value ? 'border-primary bg-primary bg-opacity-10' : 'border-secondary bg-light'} ${formDataError?.video_codec ? 'border-danger' : ''}`}
                              onClick={() => handleFfmpegInput({ target: { name: 'video_codec', value: codec.value, type: 'select-one' } })}
                              style={{ cursor: 'pointer', minHeight: '45px' }}
                            >
                              <div className="d-flex align-items-center">
                                <input
                                  type="radio"
                                  name="video_codec"
                                  value={codec.value}
                                  checked={formData?.ffmpeg_conf?.video_codec === codec.value}
                                  onChange={() => { }}
                                  className="me-2"
                                  style={{ pointerEvents: 'none' }}
                                />
                                <strong className="mb-0">{codec.name}</strong>
                              </div>
                            </div>
                          </OverlayTrigger>
                        </div>
                      ))}
                  </div>
                  {formDataError?.video_codec && (
                    <div className="mt-2">
                      <small className="text-danger">
                        <IoMdInformationCircle className="me-1" />
                        {formDataError?.video_codec}
                      </small>
                    </div>
                  )}
                  <input
                    ref={(el) => (combinedRef.current.video_codec = el)}
                    type="hidden"
                    name="video_codec"
                    value={formData?.ffmpeg_conf?.video_codec || ''}
                  />
                </div>

                {/* Preset Section */}
                <MessageLabel text={labelDisplay?.[17]?.sub_title || "Select Ffmpeg preset option"} className="mandatorySimple" />
                <AdminCustomSelect
                  key={formData?.ffmpeg_conf?.video_codec || 'no-codec'}
                  name="preset"
                  value={formData?.ffmpeg_conf?.preset || ''}
                  onChange={handleFfmpegInput}
                  options={currentPresetOptions}
                  ref={(el) => (combinedRef.current.preset = el)}
                  error={formDataError?.preset}
                  defaultOptionName={"Select preset option"}
                  disabled={!formData?.ffmpeg_conf?.video_codec}
                />

                {!formData?.ffmpeg_conf?.video_codec && (
                  <small className="text-muted mt-1 d-block">
                    Please select a video codec first to see available presets.
                  </small>
                )}
              </Wrapper>

              <Wrapper>
                <MessageHeading text="Performance Settings" />
                <div className="row">
                  <div className="col-12 col-md-6 mb-3">
                    <MessageLabel text="Queue Concurrency" />
                    <AdminCustomInput
                      name="concurrency"
                      type="number"
                      value={performanceSettings.concurrency}
                      onChange={handlePerformanceInput}
                      placeHolder="4"
                      min="1"
                      max="16"
                    />
                    <small className="text-muted">Max simultaneous transcoding jobs</small>
                  </div>
                  <div className="col-12 col-md-6 mb-3">
                    <MessageLabel text="FFmpeg Threads" />
                    <AdminCustomInput
                      name="threads"
                      type="number"
                      value={performanceSettings.threads}
                      onChange={handlePerformanceInput}
                      placeHolder="4"
                      min="1"
                      max="32"
                    />
                    <small className="text-muted">Threads per transcoding process</small>
                  </div>
                  <div className="col-12 col-md-6 mb-3">
                    <MessageLabel text="Filter Threads" />
                    <AdminCustomInput
                      name="filter_threads"
                      type="number"
                      value={performanceSettings.filter_threads}
                      onChange={handlePerformanceInput}
                      placeHolder="2"
                      min="1"
                      max="16"
                    />
                    <small className="text-muted">Threads for video filters</small>
                  </div>
                  <div className="col-12 col-md-6 mb-3">
                    <MessageLabel text="HLS Segment Duration (sec)" />
                    <AdminCustomInput
                      name="hls_time"
                      type="number"
                      value={performanceSettings.hls_time}
                      onChange={handlePerformanceInput}
                      placeHolder="10"
                      min="2"
                      max="60"
                    />
                    <small className="text-muted">Duration of each HLS segment</small>
                  </div>
                  <div className="col-12 col-md-6 mb-3">
                    <MessageLabel text="Heap Limit (MB)" />
                    <AdminCustomInput
                      name="heap_limit"
                      type="number"
                      value={performanceSettings.heap_limit}
                      readOnly={true}
                      disabled={true}
                      placeHolder="8192"
                    />
                  </div>
                </div>
              </Wrapper>
            </>
          )}
          {/* <Wrapper>
            <MessageHeading text="Multi-Tenant Configuration" />
            <FormContainer className="justify-content-between mb-3">
              <div className="col-7">
                <MessageLabel text="Multi-Tenant Status" />
              </div>
              <div className="col-5 text-end">
                <AdminSwitch
                  name="multiTenantStatus"
                  checked={formData?.multiTenantStatus || false}
                  onChange={handleMultiTenantThumbnailInput}
                />
              </div>
            </FormContainer>
            {formData?.multiTenantStatus && (
              <>
                <div className="d-flex flex-wrap align-items-center justify-content-between gap-2 mb-1">
                  <MessageLabel text="Multi-Tenant Storage Service URL" className="mb-0" />
                  <small className="text-muted fw-light" style={{ fontSize: '0.7rem', padding: '2px 8px', backgroundColor: '#f8f9fa', border: '1px solid #dee2e6', borderRadius: '12px', whiteSpace: 'nowrap' }}>
                    Not editable
                  </small>
                </div>
                <AdminCustomInput
                  id="multi-tenant-storage-url"
                  name="multiTenantStorageServiceUrl"
                  value={formData?.multiTenantStorageServiceUrl || 'http://localhost:3001'}
                  onChange={handleMultiTenantThumbnailInput}
                  error={formDataError?.multiTenantStorageServiceUrl}
                  isReadonly={true}
                />
                <div className="d-flex flex-wrap align-items-center justify-content-between gap-2 mb-1">
                  <MessageLabel text="Multi-Tenant ID" className="mb-0" />
                  <small className="text-muted fw-light" style={{ fontSize: '0.7rem', padding: '2px 8px', backgroundColor: '#f8f9fa', border: '1px solid #dee2e6', borderRadius: '12px', whiteSpace: 'nowrap' }}>
                    Not editable
                  </small>
                </div>
                <AdminCustomInput
                  id="multi-tenant-id"
                  name="multiTenantID"
                  value={formData?.multiTenantID || process.env.REACT_APP_DB_NAME || ''}
                  placeHolder="Enter tenant identifier"
                  onChange={handleMultiTenantThumbnailInput}
                  error={formDataError?.multiTenantID}
                  isReadonly={true}
                />
              </>
            )}
          </Wrapper> */}
        </RightWrapper>
      </FormContainer>
    </>
  );
}

export default Transcoding_Setting;